import gql from 'graphql-tag'
import fragments from './fragments'

export default gql`
  query SearchDuwa($filter: SearchDuwaInput!) {
    searchDuwa(filter: $filter) {
      train_number
      departure_date
      announcements {
        activity_id
        activity_type
        advertised
        advertised_time_at_location
        advertised_train_ident
        booking {
          ...duwaCodeItemFields
        }
        canceled
        deleted
        deviation {
          ...duwaCodeItemFields
        }
        estimated_time_at_location
        estimated_time_is_preliminary
        from_location {
          ...duwaLocationItemFields
        }
        information_owner
        location_signature
        mobile_web_link
        modified_time
        new_equipment
        operator
        other_information {
          ...duwaCodeItemFields
        }
        planned_estimated_time_at_location
        planned_estimated_time_at_location_is_valid
        product_information {
          ...duwaCodeItemFields
        }
        scheduled_departure_date_time
        service {
          ...duwaCodeItemFields
        }
        technical_date_time
        technical_train_ident
        time_at_location
        time_at_location_with_seconds
        to_location {
          ...duwaLocationItemFields
        }
        track_at_location
        train_composition {
          ...duwaCodeItemFields
        }
        train_owner
        type_of_traffic {
          ...duwaCodeItemFields
        }
        via_from_location {
          ...duwaLocationItemFields
        }
        via_to_location {
          ...duwaLocationItemFields
        }
        web_link
        web_link_name
      }
    }
  }

  ${fragments.duwaCodeItemFields}
  ${fragments.duwaLocationItemFields}
`
